import { Dispatch } from 'vuex';
import energy from '@/store/energy/energy';

export default {
	namespaced: true,
	modules: { energy },
	actions: {
		cleanAllEnergy({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('energy/cleanAllEnergy');
		},
	},
};
